import type {AdvancedSearchResponse} from '@api';
import {canEnterCheckoutStep, canResumeCheckoutStep, canResumeSelectionStep} from './utils/stepsValidations';

export const ADVANCED_SEARCH_CALIBRATION_PAGE_FLAG = 'advanced-search-calibration-page';

export interface StepConfig {
    routeName: string;
    skipTo?: string;
    canEnter: (advancedSearch: AdvancedSearchResponse) => boolean;
    canResume: (advancedSearch: AdvancedSearchResponse) => boolean;
    // If true, this step will be excluded from navigation history/back stack
    excludeFromHistory?: boolean;
}

/**
 * We used to have two or three workflows for the advanced search funnel.
 * Now we only have one but we kept the workflow system for future flexibility.
 * If the future team judge that it's not needed anymore, we can remove it.
 */
function getAdvancedSearchWorkflows(advancedSearchCalibrationPage: boolean) {
    return {
        unified: [
            {
                routeName: 'criteria',
                skipTo: 'checkout',
                canEnter: () => true,
                canResume: () => true,
            },
            ...(advancedSearchCalibrationPage
                ? [
                      {
                          routeName: 'calibration',
                          canEnter: () => true,
                          canResume: () => false,
                          skipTo: 'checkout',
                      },
                  ]
                : []),
            {
                routeName: 'selection',
                skipTo: 'checkout',
                canEnter: () => true,
                canResume: (advancedSearch: AdvancedSearchResponse) => canResumeSelectionStep(advancedSearch),
            },
            {
                routeName: 'checkout',
                canEnter: (advancedSearch: AdvancedSearchResponse) => canEnterCheckoutStep(advancedSearch),
                canResume: (advancedSearch: AdvancedSearchResponse) => canResumeCheckoutStep(advancedSearch),
            },
        ],
    };
}

export type AdvancedSearchWorkflows = ReturnType<typeof getAdvancedSearchWorkflows>;
export type WorkflowKey = keyof AdvancedSearchWorkflows;

export type AdvancedSearchStep<W extends WorkflowKey> = AdvancedSearchWorkflows[W][number]['routeName'];

export function getAdvancedSearchWorkflowSteps(workflowKey: WorkflowKey, advancedSearchCalibrationPage: boolean): StepConfig[] {
    return getAdvancedSearchWorkflows(advancedSearchCalibrationPage)[workflowKey];
}
